export interface StorageResult {
  value: string | null;
}

export abstract class StorageRepository {
  public abstract create(key: string, value: string): Promise<void>;
  public abstract read(key: string): Promise<StorageResult>;
  public abstract update(key: string, value: string): Promise<void>;
  public abstract delete(key: string): Promise<void>;
  public abstract clear(): Promise<void>;
}
